import React from 'react';
import { CHECKOUT_URL, PRODUCT_IMAGE } from '../data/salesContent';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function ProductImage({
  className = ''
}: {
  className?: string;
}) {
  return <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} aria-label="Comprar Sistema Primeros Auxilios para Instructores" className={`block rounded-2xl focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 ${className}`} data-id="element-36" data-mp="2lky3pwlho2h1">
      <img src={PRODUCT_IMAGE} alt="Sistema Primeros Auxilios para Instructores: 3 volúmenes y 5 bonos" className="h-auto w-full" data-id="element-37" data-mp="27mggdzzhwrzn" />
    </a>;
}